<div>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <h2>Spenden abrufen</h2>
        <button mat-icon-button (click)="dialogRef.close(imported)">
            <mat-icon class="mat-18">clear</mat-icon>
        </button>
    </div>
    <div class="line"></div>

    <div *ngIf="data.channels.length === 0">
        <div style="margin: 20px 0px">
            Es sind keine Konten angelegt. Bitte fügen Sie unter Einstellungen - Schnittstellen ein Bankkonto hinzu, um
            Ihre Spendeneingänge automatisiert abzurufen.
        </div>
        <div>
            <a (click)="dialogRef.close(imported)" routerLink="/schnittstellen/kanaele">Zu den Einstellungen</a>
        </div>
    </div>

    <div *ngFor="let channel of data.channels">
        <div class="channel" *ngIf="status.get(channel._id) === undefined">
            <div class="first">{{ channel.name }}</div>
            <div class="middle">Letzter Abruf: {{ channel.latestImport | dateToTimeSpanDays }}</div>
            <div>
                <button
                    (click)="
                        channel.finBankConnectionId
                            ? onSubmitFin(channel._id, channel.finBankConnectionId)
                            : onSubmitAltruja(channel._id)
                    "
                    [loading]="activeRequest === channel._id"
                    mat-flat-button
                    color="primary"
                >
                    Abrufen
                </button>
            </div>
        </div>
        <div
            *ngIf="status.get(channel._id) !== undefined"
            class="channel status"
            [class.active]="status.get(channel._id) !== -1"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <div>
                <mat-icon color="primary" *ngIf="status.get(channel._id) !== -1">check_circle</mat-icon>
                <mat-icon color="warn" *ngIf="status.get(channel._id) === -1">error</mat-icon>
            </div>
            <div>
                <div *ngIf="status.get(channel._id) !== -1">
                    <div class="bold">
                        {{ channel.name }}:
                        {{ status.get(channel._id)! > 0 ? status.get(channel._id) : '' }}
                        Eingänge wurden erfolgreich abgerufen
                    </div>
                    <div class="small">
                        {{ today }}: {{ status.get(channel._id) ?? '' }} Spenden wurden von
                        {{ channel.latestImport | date }} bis {{ today }} importiert
                    </div>
                </div>
                <div *ngIf="status.get(channel._id) === -1">
                    <div class="bold">{{ channel.name }}: Synchronisationsfehler</div>
                    <div class="small">
                        Spenden konnten nicht abgerufen werden. Ggf müssen Sie das Konto unter Einstellungen neu
                        verbinden.
                    </div>
                </div>
            </div>
            <div *ngIf="status.get(channel._id) === -1">
                <button
                    (click)="
                        channel.finBankConnectionId
                            ? onSubmitFin(channel._id, channel.finBankConnectionId)
                            : onSubmitAltruja(channel._id)
                    "
                    [loading]="activeRequest === channel._id"
                    mat-flat-button
                    color="warn"
                >
                    Abrufen
                </button>
            </div>
        </div>
    </div>
</div>
